import { ProjectFile, ProjectManager, isProjectFolder, visitProjectItems } from '../project'

export async function uploadProject(projectID: string) {
  const currentProjectItems = ProjectManager.shared().getCurrentItems()

  const allProjectFiles: ProjectFile[] = []
  visitProjectItems(currentProjectItems, (item, parent) => {
    if (!isProjectFolder(item)) {
      allProjectFiles.push(item)
    }
    return false
  })

  for (const projectFile of allProjectFiles) {
    if (!projectFile.fileHandle) {
      continue
    }

    const file = await projectFile.fileHandle.getFile()
    const text = await file.text()

    const response = await fetch(`/play/api/projects/${projectID}/files${projectFile.path}`, {
      method: 'PUT',
      body: text
    })
    if (!response.ok) {
      if (response.body) {
        const text = await response.text()
        throw new Error(`Could not upload file ${projectFile.path}: ${text}`)
      } else {
        throw new Error(`Could not upload file ${projectFile.path}: ${response.status}`)
      }
    }
  }
}
